import React from "react";

import { randomIntFromInterval, generateText } from "../utils";

interface PlaceholderDisplayNameProps {
  maxLength: number;
  minLength: number;
  withSuffix?: boolean;
}

/** Fake display name to show when data is loading. */
const PlaceholderDisplayName: React.FC<PlaceholderDisplayNameProps> = ({
  minLength,
  maxLength,
  withSuffix = true,
}) => {
  const length = randomIntFromInterval(maxLength, minLength);
  const acctLength = randomIntFromInterval(maxLength, minLength);

  return (
    <div className="flex flex-col text-placeholder">
      <p>{generateText(length)}</p>
      {withSuffix && <p>{generateText(acctLength)}</p>}
    </div>
  );
};

export default React.memo(PlaceholderDisplayName);
